import { render, staticRenderFns } from "./DashBoardPage.vue?vue&type=template&id=39d52c18&scoped=true&"
import script from "./DashBoardPage.vue?vue&type=script&lang=js&"
export * from "./DashBoardPage.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardPage.vue?vue&type=style&index=0&id=39d52c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d52c18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d52c18')) {
      api.createRecord('39d52c18', component.options)
    } else {
      api.reload('39d52c18', component.options)
    }
    module.hot.accept("./DashBoardPage.vue?vue&type=template&id=39d52c18&scoped=true&", function () {
      api.rerender('39d52c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/DashBoardPage.vue"
export default component.exports